import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import {
  getCallStatsThunk,
  getDashboardDataThunk,
} from "../actions/dashboard.action";

interface IDashboardData {
  number_of_calls: number;
  total_minutes: number;
  total_seconds: number;
  completion_rate: number;
  number_of_campaigns: number;
  minutes_provisioned: number;
  inbound: {
    count: number;
    completion_rate: number;
  };
  outbound: {
    count: number;
    completion_rate: number;
  };
}

export interface DashboardState {
  data: IDashboardData;
  callStats: {
    label: string;
    count: number;
  }[];
  loading: boolean;
  error: string | null;
}

// Initial state
const initialState: DashboardState = {
  data: {
    number_of_calls: 0,
    total_minutes: 0,
    total_seconds: 0,
    completion_rate: 0,
    number_of_campaigns: 0,
    minutes_provisioned: 0,
    inbound: {
      count: 0,
      completion_rate: 0,
    },
    outbound: {
      count: 0,
      completion_rate: 0,
    },
  },
  callStats: [],
  loading: false,
  error: null,
};

// Dashboard slice
const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getDashboardDataThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(getDashboardDataThunk.fulfilled, (state, action) => {
        state.data = action.payload.data;
        state.loading = false;
      })
      .addCase(getDashboardDataThunk.rejected, (state, action) => {
        state.error = action.payload as string;
        state.loading = false;
      });
    builder
      .addCase(getCallStatsThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(getCallStatsThunk.fulfilled, (state, action) => {
        state.callStats = action.payload.data;
        state.loading = false;
      })
      .addCase(getCallStatsThunk.rejected, (state, action) => {
        state.error = action.payload as string;
        state.loading = false;
      });
  },
});

export const { clearError } = dashboardSlice.actions;
export default dashboardSlice.reducer;
